import { registerPlugin } from '@capacitor/core'

export type AppleSignInCredential = {
  identityToken: string
  nonce: string
  user: string
  email?: string
  fullName?: string
}

export interface AppleSignInPlugin {
  signIn(): Promise<AppleSignInCredential>
}

export const AppleSignIn = registerPlugin<AppleSignInPlugin>('AppleSignIn')
